import React from 'react';

const CertificateStatus = ({ medicalCertificateFormData, handleChange, medicalCertificate }) => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex align-items-center gap-4">
                    <h4 className="mb-4">Certificate Status : </h4>
                    <div className="form-group d-flex align-items-center gap-4">
                        {["Final", "In progress"].map((status) => (
                            <div className="form-check me-3" key={status}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="certificateStatus"
                                    id={status.toLowerCase()}
                                    value={status}
                                    checked={medicalCertificateFormData.certificateStatus === status}
                                    onChange={handleChange}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={status.toLowerCase()}
                                >
                                    {status}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CertificateStatus